import { API_URL } from "constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (eventId, type) => `${API_URL}/api/v1/admin/data-sync?event_id=${eventId}&types=${type}`;

export const getSyncData = async (eventId, type) => await apiRequest(getUrl(eventId, type), "get");